// @ts-nocheck
import { PREFERENCES_ERROR, PREFERENCES_LOADING, PREFERENCES_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

// One flow, two services (ACOP-157): the signed-in profile edit saves through `preferences/update`, and the
// welcome survey of a brand-new person (who has no sign-in yet) through `preferences/register`.
const submit = (service, data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: PREFERENCES_LOADING,
                data: true
            })
            service(data).then((data) => {
                if (!data) {
                    dispatch({ type: PREFERENCES_ERROR, data: { message: 'Request failed. Please try again.' } })
                    return reject({ message: 'Request failed. Please try again.' });
                }
                if (data?.status === 200) {
                    dispatch({
                        type: PREFERENCES_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
                dispatch({ type: PREFERENCES_ERROR, data: { message: 'Unexpected response. Please try again.' } })
                return reject({ message: 'Unexpected response. Please try again.' });
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: PREFERENCES_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}

/** Signed-in profile edit (Profile.tsx). */
export const preferences = (data) => submit((d) => Authservices.preferences(d), data);

/** Welcome survey of a person with no record yet (Preferences.tsx). */
export const registerPreferences = (data) => submit((d) => Authservices.registerPreferences(d), data);
